module.exports = __webpack_public_path__ + "media/images/help/flow/eyecatch-box-d06b182664ba05d7207b5d4b36cddd80.svg";